<template>
    <div class="container-fluid px-0">
        <div v-if="!loadingComentarios" class="row">
            <div class="col-12">
                <h4 class="font-weight-bold">
                    {{ label || "Comentários" }}
                </h4>
            </div>
        </div>

        <div class="row" style="overflow-y: auto; overflow-x: hidden">
            <load
                v-if="loadingComentarios"
                mode="table"
                message="Aguarde, estamos verificando se existem comentários."
            />

            <div v-else-if="erroComentarios" class="col-12">
                <div class="alert alert-danger" role="alert">
                    {{ erroComentarios }}

                    <button
                        type="button"
                        class="btn btn-sm btn-outline-danger ml-2"
                        :disabled="sendComentario"
                        @click="getComentarios"
                    >
                        Tentar novamente
                    </button>
                </div>
            </div>

            <comentarios
                v-else
                :comentarios="comentarios"
                :reply="true"
                :allow-edit="true"
                :show-comment-form="showCommentForm"
                :busy="sendComentario"
                @scroll="scrollTopFormComentario"
                @editar="editarComentario"
            />
        </div>

        <div
            v-if="
                showCommentForm !== false &&
                !loadingComentarios &&
                !erroComentarios
            "
        >
            <load v-if="sendComentario" mode="table" />

            <div
                v-else
                ref="formComentario"
                class="row px-3 d-flex justify-content-end"
            >
                <div
                    v-if="editando || comentario_pai !== null"
                    class="col-12 alert alert-secondary m-0"
                    role="status"
                >
                    {{
                        editando
                            ? "Editando comentário de:"
                            : "Respondendo ao comentário de:"
                    }}

                    <b>{{ nomeComentario }}</b>
                </div>

                <div
                    v-if="erroFormulario"
                    class="col-12 alert alert-danger mt-2"
                    role="alert"
                >
                    {{ erroFormulario }}
                </div>

                <form-textarea-editor
                    v-model="descricao"
                    class="px-0"
                />

                <div class="col-auto px-0 text-right">
                    <button
                        v-if="editando || comentario_pai !== null"
                        type="button"
                        class="btn mb-3 mr-2 btn-secondary"
                        @click="cancelarAcao"
                    >
                        {{
                            editando
                                ? "Cancelar edição"
                                : "Cancelar resposta"
                        }}
                    </button>

                    <button
                        type="button"
                        class="btn mx-0 mb-3 btn-primary btn-submit"
                        @click="submit"
                    >
                        <i
                            :class="
                                editando
                                    ? 'mdi mdi-content-save'
                                    : 'mdi mdi-message-reply'
                            "
                        />

                        {{ textButton }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        model: String,
        module: String,
        id: [String, Number],
        label: String,
        textoBotao: String,

        showCommentForm: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            comentarios: [],
            descricao: "",
            sendComentario: false,
            loadingComentarios: true,
            comentario_pai: null,
            comentarioEditandoId: null,
            nomeComentario: "",
            erroComentarios: "",
            erroFormulario: "",
            geracaoContexto: 0,
            sequenciaLeitura: 0,
        };
    },

    computed: {
        editando() {
            return this.comentarioEditandoId !== null;
        },

        textButton() {
            if (this.editando) {
                return this.$t("Salvar alterações");
            }

            if (this.comentario_pai !== null) {
                return this.$t("Responder");
            }

            return this.textoBotao || this.$t("Comentar");
        },

        chaveContexto() {
            return JSON.stringify([
                this.module || this.model,
                this.model || this.module,
                String(this.id),
            ]);
        },
    },

    watch: {
        chaveContexto() {
            this.recarregarContexto();
        },

        showCommentForm(permitido) {
            if (permitido === false) {
                this.limparFormulario();
            }
        },
    },

    created() {
        this.recarregarContexto();
    },

    methods: {
        recarregarContexto() {
            this.geracaoContexto += 1;
            this.comentarios = [];
            this.limparFormulario();

            return this.getComentarios();
        },

        getComentarios() {
            const geracao = this.geracaoContexto;
            const sequencia = ++this.sequenciaLeitura;

            this.loadingComentarios = true;
            this.erroComentarios = "";

            return axios
                .get("/api/dashboard/get/comentarios", {
                    params: {
                        id: this.id,
                        module: this.module || this.model,
                        model: this.model || this.module,
                    },
                })
                .then((response) => {
                    if (
                        geracao === this.geracaoContexto &&
                        sequencia === this.sequenciaLeitura
                    ) {
                        this.comentarios = response.data.data || [];
                    }
                })
                .catch((error) => {
                    if (
                        geracao === this.geracaoContexto &&
                        sequencia === this.sequenciaLeitura
                    ) {
                        this.erroComentarios = this.mensagemErro(
                            error,
                            "Não foi possível carregar os comentários."
                        );
                    }
                })
                .finally(() => {
                    if (
                        geracao === this.geracaoContexto &&
                        sequencia === this.sequenciaLeitura
                    ) {
                        this.loadingComentarios = false;
                    }
                });
        },

        scrollTopFormComentario(comentario) {
            if (
                this.sendComentario ||
                this.loadingComentarios ||
                this.showCommentForm === false
            ) {
                return;
            }

            this.limparFormulario();

            this.comentario_pai = comentario.id;

            this.nomeComentario =
                (comentario.usuario && comentario.usuario.name) ||
                "Usuário não informado";

            this.irParaFormulario();
        },

        editarComentario(comentario) {
            const usuario =
                this.$store &&
                this.$store.state &&
                this.$store.state.user;

            if (
                this.sendComentario ||
                this.loadingComentarios ||
                this.showCommentForm === false ||
                !usuario ||
                usuario.id == null ||
                !comentario.usuario ||
                comentario.usuario.id == null ||
                String(comentario.usuario.id) !== String(usuario.id)
            ) {
                return;
            }

            this.limparFormulario();

            this.comentarioEditandoId = comentario.id;
            this.descricao = comentario.mensagem || "";

            this.nomeComentario =
                comentario.usuario.name || "Usuário não informado";

            this.irParaFormulario();
        },

        irParaFormulario() {
            this.$nextTick(() => {
                const elemento = this.$refs.formComentario;

                if (
                    elemento &&
                    typeof elemento.scrollIntoView === "function"
                ) {
                    elemento.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            });
        },

        limparFormulario() {
            this.descricao = "";
            this.comentario_pai = null;
            this.comentarioEditandoId = null;
            this.nomeComentario = "";
            this.erroFormulario = "";
        },

        cancelarAcao() {
            if (!this.sendComentario) {
                this.limparFormulario();
            }
        },

        mensagemVazia() {
            const elemento = document.createElement("div");
            elemento.innerHTML = this.descricao || "";

            const texto =
                elemento.textContent || elemento.innerText || "";

            return texto.replace(
                /[\s\u00a0\u200b-\u200d\ufeff]/g,
                ""
            ) === "";
        },

        mensagemErro(error, padrao) {
            const dados =
                error &&
                error.response &&
                error.response.data;

            if (
                dados &&
                dados.errors &&
                typeof dados.errors === "object"
            ) {
                const chaves = Object.keys(dados.errors);

                if (chaves.length) {
                    const mensagens = dados.errors[chaves[0]];

                    return Array.isArray(mensagens)
                        ? mensagens[0]
                        : mensagens;
                }
            }

            return (
                dados &&
                (
                    dados.message ||
                    (dados.error && dados.error.message)
                )
            ) || padrao;
        },

        submit() {
            if (
                this.sendComentario ||
                this.loadingComentarios ||
                this.showCommentForm === false
            ) {
                return;
            }

            if (this.mensagemVazia()) {
                this.erroFormulario =
                    "Informe o texto do comentário.";

                return;
            }

            const editando = this.editando;
            const geracao = this.geracaoContexto;

            this.sendComentario = true;
            this.erroFormulario = "";

            const requisicao = editando
                ? axios.put(
                    `/api/dashboard/comentarios/${this.comentarioEditandoId}`,
                    {
                        mensagem: this.descricao,
                    }
                )
                : axios.post("/api/dashboard/comentarios", {
                    mensagem: this.descricao,
                    comentario_pai: this.comentario_pai,
                    model: this.model || this.module,
                    module: this.module || this.model,
                    id: this.id,
                });

            return requisicao
                .then((response) => {
                    if (geracao !== this.geracaoContexto) {
                        return;
                    }

                    this.comentarios = response.data.data || [];
                    this.limparFormulario();

                    this.$snack.success({
                        button: false,
                        text: editando
                            ? "Seu comentário foi atualizado com sucesso."
                            : "Seu comentário foi salvo com sucesso.",
                    });
                })
                .catch((error) => {
                    if (geracao === this.geracaoContexto) {
                        this.erroFormulario = this.mensagemErro(
                            error,
                            "Não foi possível salvar o comentário. Tente novamente."
                        );
                    }
                })
                .finally(() => {
                    this.sendComentario = false;
                });
        },
    },
};
</script>